import {useStore} from 'vuex'
import {computed, onMounted, watch, reactive} from 'vue'
import TableComponentGeneric from '../TableComponentGeneric/TableComponentGeneric.vue'

export default {
    name: "ProductTable",
    components:{
        TableComponentGeneric
    },
    setup(){
        const store = useStore()

        const productList = computed(() => store.getters['productSearch/productsList'])
        const bulkOrder = computed(() => store.getters['bulkOrder/getProducts'])

        const productTableData = reactive({
            entries: [],
            columns: [
                {
                    "id": "quantity",
                    "order": 0,
                },
                {
                    "id": "status",
                    "order" : 1
                },
                {
                    "id": "itemName",
                    "order" : 2
                },
                {
                    "id": "itemNo",
                    "order" : 3
                },
                {
                    "id": "price",
                    "order" : 4
                },
                {
                    "id": "colli",
                    "order" : 5
                }
            ]
        })

        const noProductsToShow = computed(()=> productTableData.entries.length === 0)
        const spinnerVisible = computed(()=>store.state.productSearch.search_spinner_visible)
        const takeValue = computed(()=>store.getters['productSearch/nextTakeValue'])

        const loadMoreResults = () => {
            store.dispatch('productSearch/loadMore')
        }
        const moreResultsAvailable = computed(()=>store.getters['productSearch/moreResultsAvailable'])

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        onMounted(()=>{
            store.commit('productSearch/set_displayed_count', { displayedCount: 10 })
            store.dispatch('productSearch/performSearch',{searchString: "?q=&take=10"})
        })

        watch(productList, (newProductList)=> {
            let newProductDataEntries = []
            newProductList.forEach(product => {
                let orderedProduct = bulkOrder.value.find(bulkProduct => bulkProduct[3] === product.variantSku)
                let quantity = orderedProduct ? orderedProduct[0].value : 0
                newProductDataEntries.push([
                    {
                        value: quantity
                    },
                    product.inStock,
                    product.displayName,
                    product.variantSku,
                    product.price.formatted,
                    product.colliLabel.formatted
                ])
            })
            productTableData.entries = newProductDataEntries
        }, { deep: true })

        watch(productTableData, (newValue) => {
            store.dispatch('bulkOrder/update_products', newValue)
        }, { deep: true })

        return {
            getLabel,
            noProductsToShow,
            productTableData,
            loadMoreResults,
            takeValue,
            moreResultsAvailable,
            spinnerVisible,
        }
    }
}